import React, { Component } from 'react'
import { connect } from 'react-redux'
import { RegionActions } from 'actionsets'
import { Link } from 'react-router-dom'
import Dependent from 'containers/shared/Dependent'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography'
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import EditIcon from '@material-ui/icons/Edit'
import IconButton from '@material-ui/core/IconButton'
import { Gxp } from 'containers'

export class Show extends Component{

  constructor(props){
    super(props)
    RegionActions.bindActions(this)
  }

  dependsOn(){
    return this.actions.show(this.id)
  }

  dependenciesMet(){
    return !!this.region.id
  }

  get id(){
    return this.props.match.params.id
  }

  get region(){
    return this.props.region
  }

  render = () =>
    <Card>
      <CardContent>
        <Typography variant='h4'>Region - {this.region.name}</Typography>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell style={{width: 30}} variant='head'>Actions</TableCell>
              <TableCell>
                <Link to={`/regions/${this.region.id}/edit`}>
                  <IconButton>
                    <EditIcon/>
                  </IconButton>
                </Link>
              </TableCell>
            </TableRow>
              <TableRow>
                <TableCell variant='head'>Name</TableCell>
                <TableCell>{String(this.region.name)}</TableCell>
              </TableRow>
          </TableBody>
        </Table>
        <br/>
        <Typography variant='h5'>GXPs - {this.region.name}</Typography>
        <br/>
        <Gxp.List/>
      </CardContent>
    </Card>
}


export default connect(({regions}) => regions)(Dependent({loader: true, clearOnLoad: true})(Show))